import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { SET_NAVIGATION, SET_NAVIGATION_SERVICES } from './types';
import navigationQuery from '~/graphql/navigation.gql';
export default {
  navigationBarContent: function navigationBarContent(_ref, _ref2) {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, rootGetters, _ref2$draftId, draftId, _yield$_this$app$apol, _yield$_this$app$apol2, navigation, navigationServices;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit, rootGetters = _ref.rootGetters;
            _ref2$draftId = _ref2.draftId, draftId = _ref2$draftId === void 0 ? null : _ref2$draftId;
            _context.prev = 2;
            _context.next = 5;
            return _this.app.apolloProvider.defaultClient.query({
              fetchPolicy: 'no-cache',
              query: navigationQuery,
              variables: _objectSpread({
                locale: rootGetters['i18n/locale'].iso
              }, draftId && {
                draftId: draftId
              })
            });
          case 5:
            _yield$_this$app$apol = _context.sent;
            _yield$_this$app$apol2 = _yield$_this$app$apol.data;
            navigation = _yield$_this$app$apol2.navigation;
            navigationServices = _yield$_this$app$apol2.navigationServices;
            commit(SET_NAVIGATION, navigation);
            commit(SET_NAVIGATION_SERVICES, navigationServices);
            _context.next = 16;
            break;
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](2);
            console.log(_context.t0);
          case 16:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 13]]);
    }))();
  }
};